<template>
    <div id="login" v-if="login">
        <div class="logo">
            <img src="./../assets/images/xh_logo.png" alt="" >

        </div>
        <router-view></router-view>
        <div class="mode">
            <router-link :to="{path:'/login/logindo',query:{cburl:cburl}}"  tag="span" :class="{active:$route.name == 'Logindo'}">账号登陆</router-link> |
            <router-link :to="{path:'/login/mess',query:{cburl:cburl}}" tag="span" :class="{active:$route.name == 'Mess'}">短信登陆</router-link> |
            <!--<span @click="qqLogin">QQ</span> |-->
            <router-link :to="{path:'/login/reg',query:{cburl:cburl}}"  tag="span" :class="{active:$route.name == 'Reg'}">注册</router-link>
            <!--<router-link to="/login/forget" tag="span">忘记密码</router-link>-->
        </div>

        <p class="tk"><i class="el-icon-circle-check"></i> 我同意 <router-link :to="{path:'/service'}">"服务条款"</router-link> 和 <router-link :to="{path:'/privacy'}">"隐私策略"</router-link></p>
    </div>
</template>

<script>

    export default {
        name: "Login",
        data(){
            return {
                login : false,
                cburl : this.$route.query.cburl || '/',
            }
        },
        methods : {
            autoLogin (){
                this.axios.post('/api/login/autoLogin',{
                    'callbackurl': window.location.href
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.login = true;
                    }else if(data.code == 2){
                         location.href = data.url;
                    }else if(data.code == 1){
                        this.$message.success(data.msg);
                        //存储用户信息
                        this.$store.dispatch('setUserInfo',data.data);
                        sessionStorage.setItem('userInfo',JSON.stringify(data.data));
                        // localStorage.setItem('userInfo',JSON.stringify(data.data));
                        var _this = this;
                        // setTimeout(function () {
                            _this.$router.replace(_this.cburl);
                        // },1000)

                    }
                })
            },
            // qqLogin(){
            //     QC.Login.showPopup({
            //         appid : '101512490',
            //     })
            // },
            // qqCheckLogin(){
            //     let _this = this;
            //     if(QC.Login.check()){
            //         QC.Login.getMe(function (openid, accessToken) {
            //             console.log(openid,accessToken);
            //             QC.api('get_user_info',{}).success(function (res) {
            //                 console.log(res);
            //                 _this.axios.post('/api/login/qq',{
            //                     nickname : res.data.nickname,
            //                     cover : res.data.figureurl_2,
            //                     qqopenid : openid,
            //                     sex : res.data.gender == '男'  ? 1 : 2
            //                 }).then(r => {
            //                     let data = r.data;
            //                     _this.$message.success(data.msg);
            //                     //存储用户信息
            //                     _this.$store.dispatch('setUserInfo',data.data);
            //                     _this.$router.push(_this.cburl);
            //                 })
            //             }).error(function (res) {
            //                 _this.$message.error("QQ授权登陆失败");
            //             });
            //         })
            //
            //     }
            //
            // }
        },created(){
            let userInfo = this.$store.getters.getUserInfo;
            if(userInfo.id){
                this.$router.push('/');
            }else{
                this.autoLogin();
                // this.qqCheckLogin();
            }

        }
    }
</script>

<style lang="less">
    #login{
        .logo{text-align: center;padding:100px 0;
            img{width:400px;height:100px;}
        }

        .mode{text-align: center;color:#999;font-size: 28px;
            span{margin:0 10px;}
            span.active{color: @theme;}
        }
        .form{
            width:80%;margin:0 auto;box-sizing: border-box;border:1px solid #efefef;border-radius: 10px;overflow: hidden;


            p{position: relative;height: 96px;}
            i{position: absolute;z-index: 99;font-size: 40px;line-height: 96px;font-weight: bold;color: #999;}
            input{width: 100%;font-size:35px;position: absolute;border-radius:0;text-indent: 50px;border:none;border-bottom: 1PX solid #eee;height: 96px;line-height: 96px;z-index: 10;}
            .tool{height: 50px;line-height: 50px;
                a{font-size: 28px;}
            }
            .error-input{border-color: @theme;}
        }
        .btn{width:80%;background:@theme;color:#fff;border:none;margin:20px auto;display:block;height: 96px;font-size: 36px;border-radius: 10px !important;}

        .tk{text-align: center;font-size: 24px;color:#666;padding-top: 50px;
            i{color:red;}
            a{color:red;}
        }
    }
    

</style>
